import { render, staticRenderFns } from "./MarketCustomerEdit.vue?vue&type=template&id=6e38aea3&"
import script from "./MarketCustomerEdit.vue?vue&type=script&lang=js&"
export * from "./MarketCustomerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports